module.exports = "/_next/static/images/deliveryBox-6f01372854e1b5fd7e9be83f20997b8b.svg";